import { Pipe, PipeTransform } from '@angular/core';
import { isSameDate } from '@nk/utils-lib';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'isSameDate',
  standalone: true,
})
export class IsSameDatePipe implements PipeTransform {
  public transform(value: unknown, date: Date): boolean {
    if (
      (typeof value === 'string' || value instanceof Date) &&
      isSameDate(dayjs(value).toDate(), dayjs(date).toDate())
    ) {
      return true;
    }
    return false;
  }
}
